export default __webpack_public_path__ + "static/media/landscape.8bf2acd6.svg";